const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 109,
    viewBox: "0 0 968 232",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.942-55.525H-143.58v37.469c0 7.336-3.477 13.871-8.866 18.056h136.333C-6.142 0 1.942-8.084 1.942-18.056v-37.469z",
    style: {
      fill: "#38364d",
      fillRule: "nonzero"
    },
    transform: "translate(959.723 231.354) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.056 55.525h63.895c9.972 0 18.056-8.084 18.056-18.056V0H0c-9.972 0-18.056 8.084-18.056 18.055v37.47z",
    style: {
      fill: "#ab1738",
      fillRule: "nonzero"
    },
    transform: "translate(75.234) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.019c.728 0 1.342-.152 1.845-.455a3.62 3.62 0 0 0 1.221-1.209 5.16 5.16 0 0 0 .663-1.728c.13-.65.195-1.312.195-1.988v-9.433h4.262v9.433c0 1.282-.16 2.478-.48 3.587-.321 1.108-.815 2.079-1.482 2.91-.667.832-1.516 1.486-2.547 1.963-1.031.476-2.257.714-3.677.714-1.473 0-2.729-.251-3.769-.753-1.039-.503-1.884-1.174-2.533-2.015-.65-.84-1.127-1.815-1.43-2.923a13.158 13.158 0 0 1-.455-3.483v-9.433h4.263v9.433c0 .711.069 1.386.207 2.027.139.642.364 1.213.676 1.715.312.503.715.902 1.208 1.196.494.295 1.105.442 1.833.442",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(69.439 62.612) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.364c0-1.108.199-2.213.598-3.313a9.098 9.098 0 0 1 1.741-2.95 8.825 8.825 0 0 1 2.794-2.105c1.1-.537 2.352-.806 3.755-.806 1.646 0 3.075.373 4.288 1.117 1.213.745 2.114 1.716 2.703 2.911l-3.275 2.287a3.828 3.828 0 0 0-.727-1.208 4.056 4.056 0 0 0-.962-.78 3.674 3.674 0 0 0-1.078-.416 5.156 5.156 0 0 0-1.053-.117c-.763 0-1.421.165-1.975.494a4.386 4.386 0 0 0-1.377 1.274 5.695 5.695 0 0 0-.819 1.767A7.473 7.473 0 0 0 4.34-.208c0 .728.108 1.429.325 2.105.216.676.52 1.273.91 1.793.389.52.861.932 1.416 1.235.554.303 1.17.455 1.845.455a4.365 4.365 0 0 0 2.157-.585c.346-.2.658-.459.936-.78.277-.32.502-.714.675-1.182l3.509 2.053a5.624 5.624 0 0 1-1.209 1.819 7.48 7.48 0 0 1-1.806 1.351 9.293 9.293 0 0 1-2.144.832 9.063 9.063 0 0 1-2.222.286c-1.282 0-2.456-.273-3.521-.819a8.971 8.971 0 0 1-2.755-2.17A10.263 10.263 0 0 1 .65 3.118 9.738 9.738 0 0 1 0-.364",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(112.751 86.108) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-9.408-2.209 6.861h4.34L0-9.408zm-8.81 13.93 7.095-18.452h3.456L8.81 4.522H4.288L2.858.389h-5.743l-1.403 4.133H-8.81z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(216.926 104.845) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-10.967h-5.614V3.742h-4.262v-14.709h-5.639v-3.742H0v3.742z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(312.322 108.091) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.76c.399 0 .736-.082 1.009-.245a1.97 1.97 0 0 0 .66-.636 2.62 2.62 0 0 0 .355-.899 5.21 5.21 0 0 0 .104-1.045v-4.427h1.676v4.427c0 .595-.072 1.154-.214 1.675a3.842 3.842 0 0 1-.673 1.37 3.225 3.225 0 0 1-1.18.929c-.481.229-1.056.343-1.724.343-.694 0-1.283-.12-1.768-.361a3.29 3.29 0 0 1-1.18-.954 3.788 3.788 0 0 1-.654-1.376 6.462 6.462 0 0 1-.202-1.626v-4.427h1.687v4.427c0 .367.035.72.104 1.057.07.339.188.639.355.899.167.262.386.471.655.63.269.159.599.239.99.239",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(399.43 44.708) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.445v5.564h-1.688v-8.683h1.309l4.525 5.7v-5.687h1.687v8.67H4.464L0-2.445z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(429.343 61.67) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M419.109 455.278h1.688v8.671h-1.688z",
    transform: "translate(-1285.1 -1858.452) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-8.683 2.348 6.567 2.324-6.567h1.773L3.058 0H1.639l-3.413-8.683H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(479.385 74.666) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.723v1.48h-6.029V-1.48H-.11v1.479h-4.232v2.092h3.657v1.37h-3.657v2.262H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(535.18 44.658) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.099h2.116c.155 0 .3-.037.434-.11.135-.074.251-.173.348-.3.098-.126.176-.275.233-.446.057-.171.086-.354.086-.55 0-.204-.033-.392-.098-.563a1.46 1.46 0 0 0-.264-.447 1.18 1.18 0 0 0-.378-.293.991.991 0 0 0-.434-.104H0v2.813zm-1.687 4.391v-8.683h3.839c.4 0 .769.083 1.108.25.338.167.63.387.874.661.245.273.436.583.575.929a2.887 2.887 0 0 1-.214 2.58 2.424 2.424 0 0 1-1.143.997l2.042 3.266H3.485L1.663 1.381H0v2.911h-1.687z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(547.868 56.787) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.17a2.097 2.097 0 0 0-.312-.232 3.84 3.84 0 0 0-.549-.288 4.841 4.841 0 0 0-.704-.238 3.075 3.075 0 0 0-.771-.098c-.464 0-.81.085-1.039.257-.229.171-.343.412-.343.722 0 .179.043.328.129.446.085.118.21.222.373.312s.368.171.617.244c.249.074.536.151.863.233.424.114.809.236 1.156.367.346.13.64.293.88.489s.426.43.556.703c.131.273.196.61.196 1.009C1.052.221.965.618.789.949c-.175.33-.409.597-.703.8a2.992 2.992 0 0 1-1.027.447c-.392.093-.799.14-1.223.14a6.531 6.531 0 0 1-1.933-.293 5.973 5.973 0 0 1-1.712-.832l.747-1.455c.073.074.205.169.397.287.191.119.417.237.679.355.26.119.549.218.868.3.318.081.643.122.978.122.93 0 1.394-.298 1.394-.893a.755.755 0 0 0-.158-.489 1.352 1.352 0 0 0-.453-.342 4.283 4.283 0 0 0-.709-.269 32.236 32.236 0 0 0-.93-.257 8.09 8.09 0 0 1-1.082-.373 2.967 2.967 0 0 1-.765-.471 1.718 1.718 0 0 1-.458-.636 2.248 2.248 0 0 1-.153-.868c0-.441.081-.832.244-1.175.163-.342.39-.627.679-.856.29-.228.626-.401 1.01-.519a4.166 4.166 0 0 1 1.235-.178 4.78 4.78 0 0 1 1.687.288 6.33 6.33 0 0 1 1.345.678L0-4.17z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(596.785 65.341) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M453.988 455.278h1.688v8.671h-1.688z",
    transform: "translate(-1285.1 -1858.452) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.725h-2.764v7.204h-1.688v-7.204h-2.776v-1.479H0v1.479z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(648.152 68.508) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.683 2.141-4.5l2.176-4.183H6.14l-3.156 5.65V0H1.309v-3.058l-3.143-5.625H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(656.356 74.666) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.147c0-.53.093-1.054.281-1.571.187-.518.458-.981.813-1.388a4.115 4.115 0 0 1 1.302-.991c.514-.253 1.101-.379 1.761-.379.776 0 1.446.175 2.013.526.566.35.984.807 1.253 1.369l-1.296.893a1.931 1.931 0 0 0-.887-1.015 2.283 2.283 0 0 0-.569-.214 2.503 2.503 0 0 0-.563-.067c-.399 0-.75.086-1.051.256a2.378 2.378 0 0 0-.752.667 2.937 2.937 0 0 0-.452.93 3.608 3.608 0 0 0-.154 1.033c0 .383.06.752.178 1.107.118.354.285.666.501.935.216.269.476.486.777.649.301.163.631.244.991.244.187 0 .378-.025.575-.073a2.183 2.183 0 0 0 1.076-.642c.154-.167.281-.369.379-.606l1.382.795a2.545 2.545 0 0 1-.569.862 3.616 3.616 0 0 1-.85.63 4.408 4.408 0 0 1-1.003.392 4.215 4.215 0 0 1-1.039.134c-.604 0-1.157-.13-1.658-.391a4.329 4.329 0 0 1-1.296-1.022 4.66 4.66 0 0 1-.844-1.43A4.642 4.642 0 0 1 0-.147",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(693.61 56.937) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.683V0h1.688v7.203h4.427v1.48H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(729.89 38.491) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M490.8 455.278h1.688v8.671H490.8z",
    transform: "translate(-1285.1 -1858.452) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.445v5.564h-1.687v-8.683h1.308l4.525 5.7v-5.687h1.688v8.67h-1.37L0-2.445z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(781.506 61.67) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M503.629 455.278h1.688v8.671h-1.688z",
    transform: "translate(-1285.1 -1858.452) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.147c0-.53.094-1.054.281-1.571.188-.518.459-.981.814-1.388a4.103 4.103 0 0 1 1.302-.991c.514-.253 1.101-.379 1.761-.379.775 0 1.446.175 2.012.526.566.35.984.807 1.254 1.369l-1.297.893a1.931 1.931 0 0 0-.887-1.015 2.291 2.291 0 0 0-.568-.214 2.51 2.51 0 0 0-.563-.067c-.399 0-.75.086-1.051.256a2.367 2.367 0 0 0-.752.667 2.96 2.96 0 0 0-.453.93A3.642 3.642 0 0 0 1.7-.098c0 .383.059.752.177 1.107.118.354.285.666.502.935.216.269.475.486.776.649.302.163.632.244.991.244.187 0 .379-.025.575-.073.195-.049.385-.126.568-.233.184-.105.353-.242.508-.409.155-.167.281-.369.379-.606l1.382.795c-.13.327-.32.614-.569.862a3.63 3.63 0 0 1-.849.63 4.426 4.426 0 0 1-1.003.392 4.223 4.223 0 0 1-1.04.134c-.604 0-1.156-.13-1.658-.391a4.325 4.325 0 0 1-1.295-1.022A4.62 4.62 0 0 1 .3 1.486 4.62 4.62 0 0 1 0-.147",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(825.79 56.937) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-5.039-1.248 3.51H1.21L0-5.039zm-4.109 6.861 3.423-8.683H.685l3.412 8.683H2.312L1.517-.343h-3.046l-.795 2.165h-1.785z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(875.018 67.079) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.683V0h1.688v7.203h4.427v1.48H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(895.956 38.491) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-5.039-1.248 3.51H1.21L0-5.039zm-4.109 6.861 3.424-8.683h1.37l3.412 8.683H2.312L1.517-.343h-3.046l-.795 2.165h-1.785z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(397.647 118.037) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.099h1.957c.31 0 .568-.126.776-.379.208-.253.312-.595.312-1.027 0-.22-.032-.418-.098-.594a1.435 1.435 0 0 0-.257-.446 1.02 1.02 0 0 0-.373-.275 1.092 1.092 0 0 0-.434-.092H0v2.813zm-1.688 4.391v-8.683h3.682c.399 0 .768.083 1.106.25.338.167.63.387.875.661.244.273.436.583.574.929.139.347.208.695.208 1.046A3.028 3.028 0 0 1 4.011.488a2.69 2.69 0 0 1-.856.648 2.475 2.475 0 0 1-1.1.245H0v2.911h-1.688z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(425.622 107.745) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.725h-2.764v7.204h-1.688v-7.204h-2.776v-1.479H0v1.479z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(477.189 119.466) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M424.038 443.048h1.687v8.671h-1.687z",
    transform: "translate(-1285.1 -1756.535) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.725h-2.764v7.204h-1.687v-7.204h-2.777v-1.479H0v1.479z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(523.356 119.466) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.76c.399 0 .736-.082 1.01-.245a1.98 1.98 0 0 0 .66-.636c.167-.261.285-.56.354-.899.07-.338.105-.686.105-1.045v-4.427h1.675v4.427c0 .595-.072 1.154-.214 1.675a3.842 3.842 0 0 1-.673 1.37 3.225 3.225 0 0 1-1.18.929c-.481.229-1.056.343-1.724.343-.694 0-1.283-.12-1.768-.361a3.299 3.299 0 0 1-1.18-.954 3.821 3.821 0 0 1-.654-1.376 6.462 6.462 0 0 1-.202-1.626v-4.427h1.687v4.427c0 .367.036.72.105 1.057.069.339.187.639.354.899.167.262.386.471.655.63.269.159.599.239.99.239",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(543.126 95.666) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.025c0-.416-.058-.799-.171-1.149a2.56 2.56 0 0 0-.502-.906 2.243 2.243 0 0 0-.813-.587 2.757 2.757 0 0 0-1.094-.208h-1.468v5.724h1.468c.415 0 .784-.073 1.106-.22.323-.147.591-.348.807-.605.217-.257.382-.561.496-.911C-.058.762 0 .383 0-.025m-5.736 4.354v-8.683h3.156c.709 0 1.33.114 1.864.342.534.229.981.538 1.34.93.358.391.627.849.807 1.375.179.526.269 1.087.269 1.682 0 .661-.1 1.258-.3 1.792-.2.534-.487.99-.862 1.37a3.88 3.88 0 0 1-1.351.88 4.773 4.773 0 0 1-1.767.312h-3.156z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(589.91 107.587) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.723v1.48h-6.029V-1.48H-.11v1.479h-4.232v2.092h3.657v1.37h-3.657v2.262H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(627.718 95.616) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.725h-2.764v7.204h-1.687v-7.204h-2.777v-1.479H0v1.479z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(671.185 119.466) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.723v1.48h-6.029V-1.48H-.11v1.479h-4.232v2.092h3.657v1.37h-3.657v2.262H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(700.843 95.616) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.17a2.097 2.097 0 0 0-.312-.232 3.84 3.84 0 0 0-.549-.288 4.841 4.841 0 0 0-.704-.238 3.075 3.075 0 0 0-.771-.098c-.464 0-.81.085-1.039.257-.229.171-.343.412-.343.722 0 .179.043.328.129.446.085.118.21.222.373.312s.368.171.617.244c.249.074.536.151.863.233.424.114.809.236 1.156.367.346.13.64.293.88.489s.426.43.556.703c.131.273.196.61.196 1.009C1.052.221.965.618.789.949c-.175.33-.409.597-.703.8a2.992 2.992 0 0 1-1.027.447c-.392.093-.799.14-1.223.14a6.531 6.531 0 0 1-1.933-.293 5.973 5.973 0 0 1-1.712-.832l.747-1.455c.073.074.205.169.397.287.191.119.417.237.679.355.26.119.549.218.868.3.318.081.643.122.978.122.93 0 1.394-.298 1.394-.893a.755.755 0 0 0-.158-.489 1.352 1.352 0 0 0-.453-.342 4.283 4.283 0 0 0-.709-.269 32.236 32.236 0 0 0-.93-.257 8.09 8.09 0 0 1-1.082-.373 2.967 2.967 0 0 1-.765-.471 1.718 1.718 0 0 1-.458-.636 2.248 2.248 0 0 1-.153-.868c0-.441.081-.832.244-1.175.163-.342.39-.627.679-.856.29-.228.626-.401 1.01-.519a4.166 4.166 0 0 1 1.235-.178 4.78 4.78 0 0 1 1.687.288 6.33 6.33 0 0 1 1.345.678L0-4.17z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(727.647 116.3) scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.725h-2.764v7.204h-1.688v-7.204h-2.776v-1.479H0v1.479z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(764.235 119.466) scale(4.16667)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMin);
export default __webpack_public_path__ + "static/media/download-min.909c41f196f90c46d035ac7ca46a8ecd.svg";
export { ForwardRef as ReactComponent };